import { api } from './api'

/**
 * Descarcă un fișier al unei facturi SPV (AnafInbound). Endpoint-urile `/anaf/messages/:id/pdf|xml`
 * cer Bearer, deci NU putem naviga direct la URL / folosi `<a href>` simplu (401). Aducem blob-ul cu
 * axios (token din interceptor) și declanșăm o DESCĂRCARE printr-un anchor cu atribut `download`.
 *
 * De ce download și nu deschidere de tab: `window.open` / `<a target="_blank">` apelate DUPĂ `await`
 * sunt în afara gestului de click → Chrome le blochează. Descărcarea (`download`) NU e blocată.
 */
async function downloadBlob(path: string, filename: string): Promise<void> {
  const resp = await api.get(path, { responseType: 'blob', timeout: 60_000 })
  const objUrl = URL.createObjectURL(resp.data as Blob)
  const a = document.createElement('a')
  a.href = objUrl
  a.download = filename.replace(/[^\w.-]/g, '_')
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(objUrl), 60_000)
}

/** Descarcă PDF-ul facturii SPV. `docId` (nr. facturii, ex. SRT108120) devine numele fișierului. */
export async function openSpvPdf(inboundId: number, docId?: string | null): Promise<void> {
  await downloadBlob(
    `/anaf/messages/${inboundId}/pdf`,
    `${docId ?? `factura-spv-${inboundId}`}.pdf`,
  )
}

/** Descarcă XML-ul facturii SPV. */
export async function downloadAnafXml(inboundId: number, docId?: string | null): Promise<void> {
  await downloadBlob(
    `/anaf/messages/${inboundId}/xml`,
    `${docId ?? `factura-spv-${inboundId}`}.xml`,
  )
}
